import React from 'react';

import Chip from '@material-ui/core/Chip';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { useField } from 'formik';
import { at } from 'lodash';
import { FormHelperText } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      '& > *': {
        margin: theme.spacing(0.5),
      },
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      maxWidth: 300,
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    chip: {
      margin: 5,
    },
    noLabel: {
      marginTop: theme.spacing(10),
    },
  }),
);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

interface ComponentProps {
  name: string;
  // eslint-disable-next-line react/require-default-props
  label?: string;
  data: Array<any>;
  fullWidth: boolean;
}

const MultipleSelect = (props: ComponentProps) => {
  const { label, data, ...rest } = props;
  const [field, meta] = useField(props);
  const { value: selectedValue } = field;

  function renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');
    if (touched && error) {
      return <FormHelperText>{error}</FormHelperText>;
    }
    return null;
  }

  const classes = useStyles();

  return (
    <div>
      <FormControl {...rest} error={!!renderHelperText()}>
        <InputLabel>{label}</InputLabel>
        <Select
          {...field}
          labelId={label}
          id="demo-mutiple-chip"
          multiple
          value={selectedValue}
          input={<Input id="select-multiple-chip" />}
          renderValue={(selected) => (
            <div className={classes.chips}>
              {(selected as string[]).map((value) => (
                <Chip key={value} label={value} className={classes.chip} />
              ))}
            </div>
          )}
          MenuProps={MenuProps}
        >
          {data.map(
            (item: {
              value: string | number | undefined;
              label: string | number | undefined;
            }) => (
              <MenuItem key={item.value} value={item.label}>
                {item.label}
              </MenuItem>
            ),
          )}
        </Select>
        {renderHelperText()}
      </FormControl>
    </div>
  );
};

export default MultipleSelect;
